var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"ra-product--card",on:{"click":_vm.goToProduct}},[_c('div',{staticClass:"text"},[_c('h6',[_vm._v(_vm._s(_vm.title))]),_c('p',[_vm._v(_vm._s(_vm.label))])]),_c('div',{staticClass:"icon"},[_c('i',{class:`ra-icon--${_vm.icon}`})])])
}
var staticRenderFns = []

export { render, staticRenderFns }